import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

function FiPlanCard({
  price,
  quote,
  name,
  description,
  features = [],
  ctaText,
  isPopular = false,
  popularBadgeText,
  onCtaClick,
  isPopup = false, // 1. Recibe la prop aquí
}) {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div
        className={`plan-card-container ${
          isPopular ? "popular-highlight" : ""
        }`}
        style={{
          position: "relative",
          border: isPopular
            ? "2px solid var(--tertiary-500, #FF6D4B)"
            : "1px solid #EAECEE",
          borderRadius: "12px",
        }}
      >
        {isPopular && popularBadgeText && (
          <div
            className="popular-badge"
            style={{
              position: "absolute",
              top: "-12px",
              right: "24px",
              backgroundColor: "var(--tertiary-500, #FF6D4B)",
              padding: "6px 12px",
              borderRadius: "20px",
              color: "var(--base-white, #FFF)",
              fontFamily: "var(--fontFamily-Rubik, Rubik), sans-serif",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "100%",
              textTransform: "uppercase",
              zIndex: 2,
            }}
          >
            {popularBadgeText}
          </div>
        )}

        <div className="price-header">
          <p className="plan-price">{price}</p>
          <span className="plan-quote">{quote}</span>
        </div>
        <div className="price-body">
          <div className="plan-body-header">
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo_dark_blue.svg`}
                className="faq-card-icon"
                alt="Card Icon"
                style={{ width: "96px", height: "24px" }}
              />{" "}
              <span className="plan-name">{name}</span>
            </div>
            <p className="plan-description">{description}</p>
          </div>
          <div className="plan-body-content">
            {/* 2. Forzamos flex-wrap en la lista si estamos en un popup */}
            <ul className="card-bullets-list">
              {features.map((feature, index) => (
                // 3. Forzamos width: auto en el item para que no ocupe todo el ancho
                <li
                  key={index}
                  className="card-bullet-item"
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icons/${
                      feature.isAvailable
                        ? "check_green.svg"
                        : "close_grey_light.svg"
                    }`}
                    className="faq-card-icon"
                    alt="Feature Icon"
                  />
                  <span>
                    {feature.text}
                    {feature.strongText && (
                      <strong>{feature.strongText}</strong>
                    )}
                  </span>
                </li>
              ))}
            </ul>

            <button
              className="cta-button primary full-width"
              onClick={onCtaClick}
            >
              {ctaText}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default FiPlanCard;
